module.exports = __webpack_public_path__ + "static/media/google-logo.d8a4453c.svg";